.body {
	overflow-y: auto;
	overflow-x: hidden;
	flex: 1;
	display: block;
	min-height: 0;
	scrollbar-width: thin;
	scrollbar-color: var(--border-primary) transparent;
	background-color: var(--elevation-default);
	padding: 0 8px;
}

.bodyScrollbarVisible {
	padding: 0 0 0 8px !important;
}

.body::-webkit-scrollbar {
	width: 8px;
}

.body::-webkit-scrollbar-track {
	background: transparent;
}

.body::-webkit-scrollbar-thumb {
	background-color: var(--border-primary);
	border-radius: 4px;
}

.body::-webkit-scrollbar-thumb:hover {
	background-color: var(--content-tertiary);
}

.bodyScrollbarVisible tr:last-child {
	border-bottom: none;
}
